import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { httpinstance,httpinstancefile } from "../../../axios/api"


export const get_rate_list = createAsyncThunk('get_rate_list', async (queryParams)=>{
    try{
        const url = `admin/list_rateplan${queryParams}`
        const response = await httpinstance.get(url)
        return response
    }catch (err){
        return err.response
    }
})

export const get_vas_rate_list = createAsyncThunk('get_vas_rate_list', async (queryParams)=>{
    try{
        const url = `admin/vas_rate_list${queryParams}`
        const response = await httpinstance.get(url)
        console.log(response)
        return response
    }catch (err){
        return err.response
    }
})

export const getIncoTerms = createAsyncThunk(
    'rateManagement/getIncoTerms',
    async (_, { rejectWithValue }) => {
      try {
        const response = await httpinstance.get('/airVas/rate/getIncoTerms');
        return response.data.data;
      } catch (err) {
        return rejectWithValue(err.response?.data || 'Something went wrong');
      }
    }
  );
export const get_vas_rate_list_data = createAsyncThunk('get_vas_rate_list_data', async (queryParams)=>{
    try{
        const url = `/airVas/rate`
        const response = await httpinstance.get(url)
        console.log(response)
        return response
    }catch (err){
        return err.response
    }
})

export const get_surcharge_rate_list = createAsyncThunk('get_surcharge_rate_list', async (queryParams)=>{
    try{
        const url = `admin/surchargelist${queryParams}`
        const response = await httpinstance.get(url)
        console.log(response);   
        return response
    }catch (err){
        return err.response
    }
})

export const create_vas_rate = createAsyncThunk('create_vas_rate', async (values)=>{
    try{
        const url = 'admin/add_single_vas_rate'
        const response = await httpinstance.post(url,values)
        return response
    }catch (err){
        return err.response
    }
})

export const move_rate_archive = createAsyncThunk('move_rate_archive', async (values)=>{
    try{
        const url = 'admin/rate_move_to_archive'
        const response = await httpinstance.post(url,values)
        return response
    }catch (err){
        return err.response
    }
})

export const get_transport_rate_list = createAsyncThunk('get_transport_rate_list', async (queryParams)=>{
    try{
        const url = `admin/transportationlist${queryParams}`
        const response = await httpinstance.get(url)
        return response
    }catch (err){
        return err.response
    }
})

const initialState = {
    data:{},
    loading:false,
    // loading: false,
    incoTerms: [],
    error: '',
}

const rate_managementSlice = createSlice({
    name : 'rate_management',
    initialState,
    reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getIncoTerms.pending, (state) => {
        state.loading = true;
      })
      .addCase(getIncoTerms.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.incoTerms = payload;
        state.error = '';
      })
      .addCase(getIncoTerms.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      });
  },
})
export default rate_managementSlice.reducer